import type { Workflow } from "@stockline/shared/types/ai/workflow"
import { WORKFLOW_TABLE } from "../../../lib/offline/resources/ai/workflow/db"
import { useAISync } from "../providers/AISyncProvider"

export function useWorkflow(id: string): Workflow | null {
  const { reactive } = useAISync()
  return reactive.useOne<Workflow>(WORKFLOW_TABLE, id)
}
